import React from 'react'
import useSteps from '../../hooks/useSteps'

export default function PrevStepButton ({ label, style = 'default' }) {
  const { prevStep } = useSteps()

  return (
    <button className={['button', style].join(' ')} onClick={prevStep} style={{marginLeft: '0'}}>
      {label}
    </button>
  )
}
